
    <router-outlet *ngIf="!isIframe"></router-outlet>
    <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
